import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Notifications from "../helpers/toast-notifications";
import i18n from "../i18n";
import tablesStore from "./tablesStore";
import representativeStore from "./modules/representative/representativeStore";
import mainViewsStore from "./modules/mainViews/mainViewsStore";
import buffetMainViewStore from "./modules/buffet/buffetMainViewStore";
import gradeEduclassShared from "./modules/mainViews/grade-educationClass-shared/store";
import studentStore from "./modules/students/studentStore";
import parents from "./modules/users/parents";
import admins from "./modules/users/admins";
import teachersStore from "./modules/teachers/teachersStore";
import cashierFinancialOrder from "./modules/financial-order/cashierFinancialOrder";
import accountantFinancialOrder from "./modules/financial-order/accountantFinancialOrder";
import costCenter from "./modules/costCenter";
import cashierBox from "./modules/cashierBox";
import router from "../router";
import timeAttendance from "@/store/modules/HR/time_attendence";
import employees from "@/store/modules/HR/employees";
import calculations from "@/store/modules/HR/calculations";
import loans from "@/store/modules/HR/loans";
import payments from "@/store/modules/HR/payments";
import vacations from "@/store/modules/HR/vacations";
import variations from "@/store/modules/HR/variations";
import payinstallment from "@/store/modules/pay-installments/payinstallment";
import restrictions from "@/store/modules/restrictions";
import procurements from "./modules/procurements/procurementsStore"
import sales from "./modules/sales/salesStore"
import currencies from "@/store/modules/currencies/currencies";
import car from "@/store/modules/car/carStore";
import { messaging, getToken, onMessage } from "@/firebase";

Vue.use(Vuex);

const ecommerceStore = {
  namespaced: true,
  modules: {
    products: {
      namespaced: true,
      state: () => ({
        products: [
          {
            "id": 101,
            "name": "Samsung Smart TV 55\"",
            "categoryId": 1,
            "brandId": 1,
            "price": 900,
            "discount": 15,
            "image": "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400&h=300&fit=crop",
            "description": "55-inch 4K Smart TV with HDR support"
          },
          {
            "id": 104,
            "name": "Samsung Washing Machine 8KG",
            "categoryId": 3,
            "brandId": 1,
            "price": 650,
            "discount": 5,
            "image": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
            "description": "High-performance washing machine with eco mode"
          },
          {
            "id": 101,
            "name": "Samsung Smart TV 55\"",
            "categoryId": 1,
            "brandId": 1,
            "price": 900,
            "discount": 15,
            "image": "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400&h=300&fit=crop",
            "description": "55-inch 4K Smart TV with HDR support"
          },
          {
            "id": 104,
            "name": "Samsung Washing Machine 8KG",
            "categoryId": 3,
            "brandId": 1,
            "price": 650,
            "discount": 5,
            "image": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
            "description": "High-performance washing machine with eco mode"
          },
          {
            "id": 101,
            "name": "Samsung Smart TV 55\"",
            "categoryId": 1,
            "brandId": 1,
            "price": 900,
            "discount": 15,
            "image": "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400&h=300&fit=crop",
            "description": "55-inch 4K Smart TV with HDR support"
          },
          {
            "id": 102,
            "name": "LG Refrigerator 420L",
            "categoryId": 2,
            "brandId": 3,
            "price": 1200,
            "discount": 0,
            "image": "https://images.unsplash.com/photo-1571175443880-49e1d1b7b3c4?w=400&h=300&fit=crop",
            "description": "Energy-efficient refrigerator with modern design"
          },
          {
            "id": 103,
            "name": "Apple iPhone 14",
            "categoryId": 4,
            "brandId": 2,
            "price": 1100,
            "discount": 10,
            "image": "https://images.unsplash.com/photo-1672502493406-c976ce4ea0a9?w=400&h=300&fit=crop",
            "description": "Latest iPhone with advanced camera system"
          },
          {
            "id": 104,
            "name": "Samsung Washing Machine 8KG",
            "categoryId": 3,
            "brandId": 1,
            "price": 650,
            "discount": 5,
            "image": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
            "description": "High-performance washing machine with eco mode"
          },
        ],
        categories: [
          { "id": 1, "name": "TVs" },
          { "id": 2, "name": "Refrigerators" },
          { "id": 3, "name": "Washing Machines" },
          { "id": 4, "name": "Mobile Phones" }
        ],
        brands: [
          { "id": 1, "name": "Samsung" },
          { "id": 2, "name": "Apple" },
          { "id": 3, "name": "LG" },
          { "id": 4, "name": "Sony" }
        ],
        filteredProducts: [],
        searchQuery: '',
        selectedCategory: null,
        selectedBrand: null
      }),
      mutations: {
        SET_FILTERED_PRODUCTS(state, products) {
          state.filteredProducts = products
        },
        SET_SEARCH_QUERY(state, query) {
          state.searchQuery = query
        },
        SET_SELECTED_CATEGORY(state, categoryId) {
          state.selectedCategory = categoryId
        },
        SET_SELECTED_BRAND(state, brandId) {
          state.selectedBrand = brandId
        }
      },
      actions: {
        filterProducts({ commit, state }) {
          let filtered = state.products

          if (state.searchQuery) {
            const query = state.searchQuery.toLowerCase()
            filtered = filtered.filter(product =>
              product.name.toLowerCase().includes(query) ||
              product.description.toLowerCase().includes(query)
            )
          }

          if (state.selectedCategory) {
            filtered = filtered.filter(
              product => product.categoryId === state.selectedCategory
            )
          }

          if (state.selectedBrand) {
            filtered = filtered.filter(
              product => product.brandId === state.selectedBrand
            )
          }

          commit('SET_FILTERED_PRODUCTS', filtered)
        },
        updateSearchQuery({ commit, dispatch }, query) {
          commit('SET_SEARCH_QUERY', query)
          dispatch('filterProducts')
        },
        updateCategoryFilter({ commit, dispatch }, categoryId) {
          commit('SET_SELECTED_CATEGORY', categoryId)
          dispatch('filterProducts')
        },
        updateBrandFilter({ commit, dispatch }, brandId) {
          commit('SET_SELECTED_BRAND', brandId)
          dispatch('filterProducts')
        },
        clearFilters({ commit, dispatch }) {
          commit('SET_SEARCH_QUERY', '')
          commit('SET_SELECTED_CATEGORY', null)
          commit('SET_SELECTED_BRAND', null)
          dispatch('filterProducts')
        }
      },
      getters: {
        getProductById: (state) => (id) => {
          return state.products.find(product => product.id === parseInt(id))
        },
        getAllProducts: (state) => {
          return state.filteredProducts.length ? state.filteredProducts : state.products
        }
      }
    },
    cart: {
      namespaced: true,
      state: () => ({
        items: [],
        isCartOpen: false
      }),
      mutations: {
        ADD_TO_CART(state, { product, quantity = 1 }) {
          const existingItem = state.items.find(item => item.id === product.id)

          if (existingItem) {
            existingItem.quantity += quantity
          } else {
            state.items.push({
              ...product,
              quantity
            })
          }
        },
        REMOVE_FROM_CART(state, productId) {
          state.items = state.items.filter(item => item.id !== productId)
        },
        UPDATE_QUANTITY(state, { productId, quantity }) {
          const item = state.items.find(item => item.id === productId)
          if (item) {
            item.quantity = quantity
          }
        },
        CLEAR_CART(state) {
          state.items = []
        },
        TOGGLE_CART(state) {
          state.isCartOpen = !state.isCartOpen
        },
        SET_CART_OPEN(state, isOpen) {
          state.isCartOpen = isOpen
        }
      },
      actions: {
        addToCart({ commit, dispatch, rootState }, { productId, quantity = 1 }) {
          // Check if user is authenticated
          if (!rootState.auth?.isAuthenticated) {
            // Show OTP modal
            commit('ecommerce/auth/SET_OTP_MODAL', true, { root: true })
            return
          }

          const product = rootState.ecommerce.products.products.find(p => p.id === productId)
          if (product) {
            commit('ADD_TO_CART', { product, quantity })
          }
        },
        removeFromCart({ commit }, productId) {
          commit('REMOVE_FROM_CART', productId)
        },
        updateQuantity({ commit }, { productId, quantity }) {
          commit('UPDATE_QUANTITY', { productId, quantity })
        },
        toggleCart({ commit }) {
          commit('TOGGLE_CART')
        }
      },
      getters: {
        cartItems: (state) => state.items,
        cartTotal: (state) => {
          return state.items.reduce((total, item) => {
            const price = item.price * (1 - (item.discount || 0) / 100)
            return total + (price * item.quantity)
          }, 0).toFixed(2)
        },
        cartItemCount: (state) => {
          return state.items.reduce((count, item) => count + item.quantity, 0)
        },
        isCartOpen: (state) => state.isCartOpen
      }
    },
    auth: {
      namespaced: true,
      state: () => ({
        isAuthenticated: false,
        user: null,
        showOTPModal: false,
        phoneNumber: ''
      }),
      mutations: {
        SET_AUTHENTICATED(state, isAuthenticated) {
          state.isAuthenticated = isAuthenticated
        },
        SET_USER(state, user) {
          state.user = user
        },
        SET_OTP_MODAL(state, show) {
          state.showOTPModal = show
        },
        SET_PHONE_NUMBER(state, phone) {
          state.phoneNumber = phone
        }
      },
      actions: {
        showOTPModal({ commit }) {
          commit('SET_OTP_MODAL', true)
        },
        hideOTPModal({ commit }) {
          commit('SET_OTP_MODAL', false)
        },
        async verifyOTP({ commit, state }, otp) {
          // Mock OTP verification
          if (otp === '123456' && state.phoneNumber) {
            commit('SET_AUTHENTICATED', true)
            commit('SET_USER', { phone: state.phoneNumber })
            commit('SET_OTP_MODAL', false)
            return true
          }
          return false
        },
        logout({ commit }) {
          commit('SET_AUTHENTICATED', false)
          commit('SET_USER', null)
        }
      }
    }
  }
}

function getLeftmostLabel(url) {
  const h = new URL(url).hostname;
  if (!h) return null;
  const parts = h.split('.');
  if (parts[0] === 'www' && parts.length > 1) return parts[1];
  return parts[0];
}

function getServerDomain() {
  const origin = window.location.origin;
  if (origin.includes("localhost") || origin.includes("127.0.0.1") || origin.includes("192")) {
    let url = origin.replace("http://localhost:8080", "https://demo.inventive-dev.com");
    axios.defaults.headers.common["domain"] = "demo";
    return "https://tenant.incentive-dev.com";
    // return "https://lbbis-back.incentive-dev.com";
  }
  else if (origin.includes("kareem-alsham") || origin.includes("lbbis") || origin.includes("sana-poetic")) {
    return origin.replace(".incentive-dev.com", "-back.incentive-dev.com");
  }
  else {
    let url = origin;
    axios.defaults.headers.common["domain"] = getLeftmostLabel(url);
    return "https://tenant.incentive-dev.com";
  }
}

function getServerDomainApi() {
  return getServerDomain() + "/api";
}

export default new Vuex.Store({
  state: {
    serverDomain: getServerDomain(),
    serverDomainApi: getServerDomainApi(),
    barImage: "",
    appBarFire: true,
    drawer: null,
    userData: {
      username: "",
      abilities: [],
    },
    termModel: [],
    drawerList: [],
    imageSchoolBase64: null,
    schSetting: {
      SCHOOL_NAME: 'Incentive',
      COIN_CODE: '€',
      COIN_NAME: 'Euro',
      SCHOOL_IMAGE: require("@/assets/Logo 2.png"),
    },
    activeDash: true,
    routeNameAddition: "",
    isDarkMode: false,
    acTapHrIn: 0,
    tabRoute: 0,
    tabTrip: 0,
    tabAi: 0,
    tabWorkFlow: 0,
    tabTeachers: 0,
    studentTap: 0,
  },
  mutations: {
    SET_DRAWER_LIST(state, payload) {
      state.drawerList = payload;
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_ACTIVE_DASH(state, payload) {
      state.activeDash = payload;
    },
    setUserData(state, userInfo) {
      state.userData.username = userInfo.user_name;
      state.userData.abilities = userInfo.ability;
    },
    setTermModel(state, payload) {
      state.termModel = payload;
    },
    setRouteNameAddition(state, addition) {
      state.routeNameAddition = addition;
    },
    SET_DARK_MODE(state, payload) {
      state.isDarkMode = payload;
    },
    SET_ACTABHRIN(state, payload) {
      state.acTapHrIn = payload;
    },
    SET_TABROUTE(state, payload) {
      state.tabRoute = payload;
    },
    SET_TABTRIP(state, payload) {
      state.tabTrip = payload;
    },
    SET_TABAI(state, payload) {
      state.tabAi = payload;
    },
    SET_TABWORKFLOW(state, payload) {
      state.tabWorkFlow = payload;
    },
    SET_TABTEACHERS(state, payload) {
      state.tabTeachers = payload;
    },
    SET_studentTab(state, payload) {
      state.studentTap = payload;
    },
  },
  actions: {
    async registerFcmToken() {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;
        const fcmToken = await getToken(messaging, {
          vapidKey: "BOp0GthTQVwcx0CzqOcdNo8KwV1E-uPmFW-kATf1svkA3mNcdjxUaYZR893If6gIbxRqW09nLpoTlNvFa3brE-c"
        });
        console.log('FCM Token:', fcmToken);
        if (fcmToken) {
          await axios.post('/device-token', {
            token: fcmToken,
          });
        }
      } catch (err) {
        console.error('Token error:', err);
      }
    },
    async userLogin({ commit, dispatch }, userData) {
      try {
        axios.defaults.headers.common["term"] = userData.termId;
        if (userData.password.length < 8) {
          const logInResponse = await axios.post("/auth/parent/login", {
            phone: userData.username,
            password: userData.password,
          });
          localStorage.setItem("access_token", logInResponse.data.data.token);
          localStorage.setItem("tenant", logInResponse.data.data.tenant);
          axios.defaults.headers.common["Authorization"] = "Bearer " + logInResponse.data.data.token;
          axios.defaults.headers.common["X-Tenant-Id"] = logInResponse.data.data.tenant;
          router.replace("/studentApp");
        }
        if (userData.password.length > 7) {
          const logInResponse = await axios.post("/auth/login", {
            username: userData.username,
            password: userData.password,
          });
          localStorage.setItem("term", logInResponse.data.data.term.id);
          localStorage.setItem("termModel", JSON.stringify(logInResponse.data.data.term));
          console.log("login response", logInResponse);
          commit("setUserData", logInResponse.data.data);
          commit("setTermModel", logInResponse.data.data.term);
          localStorage.setItem("school_user_data", JSON.stringify(logInResponse.data.data));
          localStorage.setItem("access_token", logInResponse.data.data.access_token);
          localStorage.setItem("tenant", logInResponse.data.data.tenant);
          axios.defaults.headers.common["Authorization"] = "Bearer " + logInResponse.data.data.access_token;
          axios.defaults.headers.common["X-Tenant-Id"] = logInResponse.data.data.tenant;
          Notifications(i18n.t("login success"), { timeout: 1000, rtl: true }, "success");
          const response = await axios.get("/semester", { params: { term_id: logInResponse.data.data.term.id, }, });
          localStorage.setItem("semester", response.data.data.at(-1).id);
          axios.defaults.headers.common["semester"] = response.data.data.at(-1).id;
          axios.defaults.headers.common["term"] = localStorage.getItem("term");
          localStorage.setItem("semesterModel", JSON.stringify(response.data.data.at(-1)));
          await dispatch("registerFcmToken");
          router.replace("/");
        }


      } catch (err) {
      } finally {
      }
    },
    autoLogIn({ commit }) {
      commit("setUserData", JSON.parse(localStorage.getItem("school_user_data")));
      commit("setTermModel", JSON.parse(localStorage.getItem("termModel")));
      axios.defaults.headers.common["term"] = localStorage.getItem("term");
      axios.defaults.headers.common["semester"] = localStorage.getItem("semester");
      axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("access_token");
      axios.defaults.headers.common["X-Tenant-Id"] = localStorage.getItem("tenant");
    },
  },
  getters: {
    getUserName(state) {
      return state.userData.username;
    },
    getUserAbilities(state) {
      return state.userData.abilities;
    },
    getRouteNameAddition(state) {
      return state.routeNameAddition;
    },
  },
  modules: {
    tablesStore,
    ...mainViewsStore,
    ...buffetMainViewStore,
    ...studentStore,
    ...teachersStore,
    ...gradeEduclassShared,
    ...representativeStore,
    ...procurements,
    ...sales,
    ...car,
    costCenter,
    cashierBox,
    parents,
    admins,
    cashierFinancialOrder,
    accountantFinancialOrder,
    timeAttendance,
    employees,
    calculations,
    loans,
    payments,
    vacations,
    variations,
    payinstallment,
    restrictions,
    currencies,
    ecommerce: ecommerceStore
  },
});
